const hy = {
  title: 'Պոդկաստ նախագծի մասին',
  source: 'Աղբյուր',
  link: 'https://itx.com/podcast/51-cognitive-bias-and-software-development/',
  podcastLink:
    'https://content.blubrry.com/itx_product_momentum/episode51promo.mp3?_=1',
};

export default hy;
